import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const MaskLines = ({ lines, className = "", lineClass = "", delay = 0, as = "h1", goldLast = true, testid }) => {
  const Tag = motion[as];
  return (
    <Tag className={className} data-testid={testid} initial="hidden" animate="show">
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em]">
          <motion.span
            className={`block ${lineClass} ${goldLast && i === lines.length - 1 ? "text-gold-gradient" : ""}`}
            variants={{ hidden: { y: "105%" }, show: { y: "0%" } }}
            transition={{ duration: 1.1, ease: EASE, delay: delay + i * 0.12 }}
          >
            {l}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const FadeUp = ({ children, delay = 0, className = "", y = 28, ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const GoldRule = ({ className = "", delay = 0 }) => (
  <motion.span
    className={`block h-px bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent origin-left ${className}`}
    initial={{ scaleX: 0 }}
    whileInView={{ scaleX: 1 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 1.4, ease: EASE, delay }}
  />
);

export const Overline = ({ children, className = "" }) => (
  <p className={`flex items-center gap-3 text-[11px] uppercase tracking-[0.32em] text-[#D4AF37] font-semibold ${className}`}>
    <span className="h-px w-8 bg-[#D4AF37]" />
    {children}
  </p>
);
